import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatIconModule} from '@angular/material/icon'
import { InfoCardComponent } from './info-card/info-card.component';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { MatCardModule } from '@angular/material/card';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {StatusCardComponent} from './status-card/status-card.component'

@NgModule({
  declarations: [
    InfoCardComponent,
    StatusCardComponent
    
  ],
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatCardModule,
    MatIconModule,
    AppMaterialModule
  ],
  exports: [
    InfoCardComponent,
    StatusCardComponent,
  ]
})
export class CardModule { }
